export default __webpack_public_path__ + "static/media/Freebooter's Leggings of the Untamed.d35316a6.jpg";